module.exports = __webpack_public_path__ + "static/media/director-onboarding-persona-lisa.35f1451a.png";